const LoadingSkeleton = () => {
  return (
    <div className="mx-auto max-w-screen-lg animate-pulse py-8 md:px-4 ">
      <h2 className="bg-mono-200 dark:bg-mono-900 mx-auto h-10  max-w-screen-sm rounded-md pb-4 text-xl md:mb-6 md:text-2xl" />
      <div className="grid grid-cols-1  justify-center gap-x-6 gap-y-8">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="mx-auto w-full max-w-screen-sm">
            <div
              key={i}
              className={`dark:border-mono-700/50 grid gap-2  rounded-md border p-4 md:grid-cols-1`}
            >
              <div className={`bg-mono-200 dark:bg-mono-900  h-6`} />
              <div className={`bg-mono-200 dark:bg-mono-900  h-14`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;
